import React, { useState } from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  IconButton,
  TextField,
  Button,
  InputAdornment,
  useTheme,
  useMediaQuery,
  Link,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import Logo from "../../../../assets/logo/text-logo.png";

const SocialIcon: React.FC<{ type: string }> = ({ type }) => {
  const icons = {
    facebook: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
        <path d="M14 13.5h2.5l1-4H14v-2c0-1.03 0-2 2-2h1.5V2.14c-.326-.043-1.557-.14-2.857-.14C11.928 2 10 3.657 10 6.7v2.8H7v4h3V22h4v-8.5z" />
      </svg>
    ),
    linkedin: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
        <path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z" />
      </svg>
    ),
    instagram: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2c2.717 0 3.056.01 4.122.06 1.065.05 1.79.217 2.428.465.66.254 1.216.598 1.772 1.153a4.908 4.908 0 0 1 1.153 1.772c.247.637.415 1.363.465 2.428.047 1.066.06 1.405.06 4.122 0 2.717-.01 3.056-.06 4.122-.05 1.065-.218 1.79-.465 2.428a4.883 4.883 0 0 1-1.153 1.772 4.915 4.915 0 0 1-1.772 1.153c-.637.247-1.363.415-2.428.465-1.066.047-1.405.06-4.122.06-2.717 0-3.056-.01-4.122-.06-1.065-.05-1.79-.218-2.428-.465a4.89 4.89 0 0 1-1.772-1.153 4.904 4.904 0 0 1-1.153-1.772c-.248-.637-.415-1.363-.465-2.428C2.013 15.056 2 14.717 2 12c0-2.717.01-3.056.06-4.122.05-1.066.217-1.79.465-2.428a4.88 4.88 0 0 1 1.153-1.772A4.897 4.897 0 0 1 5.45 2.525c.638-.248 1.362-.415 2.428-.465C8.944 2.013 9.283 2 12 2zm0 5a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm6.5-.25a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0zM12 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6z" />
      </svg>
    ),
    whatsapp: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
        <path d="M19.05 4.91A9.816 9.816 0 0 0 12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01zm-7.01 15.24c-1.48 0-2.93-.4-4.2-1.15l-.3-.18-3.12.82.83-3.04-.2-.31c-.82-1.31-1.26-2.83-1.26-4.38 0-4.54 3.7-8.24 8.24-8.24 2.2 0 4.27.86 5.82 2.42a8.236 8.236 0 0 1 2.41 5.83c.02 4.54-3.68 8.23-8.22 8.23zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.12-.17.25-.64.81-.78.97-.14.17-.29.19-.54.06-.25-.12-1.05-.39-1.99-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.02-.38.11-.51.11-.11.25-.29.37-.43s.17-.25.25-.41c.08-.17.04-.31-.02-.43s-.56-1.34-.76-1.84c-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31-.22.25-.87.85-.87 2.07 0 1.22.89 2.4 1.01 2.56.12.17 1.75 2.67 4.23 3.74.59.26 1.05.41 1.41.52.59.19 1.13.16 1.56.1.48-.07 1.47-.6 1.67-1.18.21-.58.21-1.07.14-1.18s-.22-.16-.47-.28z" />
      </svg>
    ),
    website: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-.61.08-1.21.21-1.78L8.99 15v1c0 1.1.9 2 2 2v1.93C7.06 19.43 4 16.07 4 12zm13.89 5.4c-.26-.81-1-1.4-1.9-1.4h-1v-3c0-.55-.45-1-1-1h-6v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41C17.92 5.77 20 8.65 20 12c0 2.08-.81 3.98-2.11 5.4z" />
      </svg>
    ),
  };

  return icons[type as keyof typeof icons] || null;
};

export const Footer: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [email, setEmail] = useState("");

  const footerLinks = {
    product: {
      title: "Product",
      links: [
        { label: "Features", path: "/features" },
        // { label: "Pricing", path: "/pricing" },
        { label: "Book a Demo", path: "/contact" },
      ],
    },
    company: {
      title: "Company",
      links: [
        { label: "About Us", path: "/about" },
        // { label: "Careers", path: "https://venustusy.com/contact" },
        { label: "Contact", path: "/contact" },
      ],
    },
    // resources: {
    //   title: "Resources",
    //   links: [
    //     { label: "Help Center", path: "/help" },
    //     { label: "Blog", path: "/blog" },
    //     { label: "Documentation", path: "/docs" },
    //   ],
    // },
    legal: {
      title: "Legal",
      links: [
        { label: "Terms of Service", path: "/terms" },
        { label: "Privacy Policy", path: "/privacy" },
      ],
    },
  };

  const socialLinks = [
    {
      icon: "facebook",
      url: "https://www.facebook.com/people/Offical-Venustusy/",
      label: "Facebook",
      color: "#1877F2",
    },
    {
      icon: "linkedin",
      url: "https://www.linkedin.com/company/venustusy-it/",
      label: "LinkedIn",
      color: "#0A66C2",
    },
    {
      icon: "instagram",
      url: "https://www.instagram.com/venustusy.t/#",
      label: "Instagram",
      gradient:
        "linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)",
    },
    {
      icon: "whatsapp",
      url: "https://wa.me/97336200663",
      label: "WhatsApp",
      color: "#25D366",
    },
    {
      icon: "website",
      url: "https://venustusy.com/",
      label: "Website",
      color: "#06B6D4",
    },
  ];

  return (
    <Box
      component="footer"
      sx={{
        pt: { xs: 8, md: 12 },
        pb: { xs: 4, md: 6 },
        background: "linear-gradient(135deg, #000B18 0%, #001E3C 100%)",
        position: "relative",
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background:
            "radial-gradient(circle at 50% 50%, rgba(6, 182, 212, 0.03) 0%, transparent 70%)",
          zIndex: 0,
        },
      }}
    >
      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
        <Grid container spacing={4}>
          {/* Branding Section */}
          <Grid item xs={12} md={4}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
            >
              <Box sx={{ mb: 4 }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mb: 3,
                  }}
                >
                  {/* <Logo
                    style={{
                      height: "40px",
                      width: "auto",
                      marginRight: "12px",
                    }}
                  /> */}

                  <img
                    src={Logo}
                    alt="VenFlows"
                    style={{
                      height: "40px",
                      width: "auto",
                      marginRight: "12px",
                    }}
                  />
                </Box>
                <Typography
                  variant="subtitle1"
                  sx={{
                    mb: 2,
                    color: "rgba(255, 255, 255, 0.9)",
                    fontFamily: "Montserrat",
                    fontWeight: 500,
                  }}
                >
                  The Backbone of Smart Restaurant Operations
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    mb: 3,
                    color: "rgba(255, 255, 255, 0.6)",
                    fontFamily: "Montserrat",
                  }}
                >
                  Built for control. Designed for scale.
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    gap: 1.5,
                    mt: 4,
                    alignItems: "center",
                  }}
                >
                  {socialLinks.map((social) => (
                    <IconButton
                      key={social.icon}
                      href={social.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={social.label}
                      sx={{
                        width: 40,
                        height: 40,
                        backgroundColor: "rgba(255, 255, 255, 0.03)",
                        backdropFilter: "blur(10px)",
                        border: "1px solid rgba(255, 255, 255, 0.1)",
                        color: "rgba(255, 255, 255, 0.8)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                        "&:hover": {
                          backgroundColor: "rgba(255, 255, 255, 0.1)",
                          transform: "translateY(-2px)",
                          color: social.gradient ? "white" : social.color,
                          borderColor: social.gradient
                            ? "rgba(255, 255, 255, 0.2)"
                            : social.color,
                          background:
                            social.gradient || "rgba(255, 255, 255, 0.1)",
                          boxShadow: `0 4px 12px rgba(0, 0, 0, 0.1)`,
                        },
                        "&:active": {
                          transform: "translateY(0)",
                        },
                      }}
                    >
                      <SocialIcon type={social.icon} />
                    </IconButton>
                  ))}
                  <Typography
                    variant="body2"
                    sx={{
                      color: "rgba(255, 255, 255, 0.4)",
                      ml: 1,
                      fontFamily: "Montserrat",
                      fontSize: "0.875rem",
                      letterSpacing: "0.01em",
                    }}
                  >
                    Follow us
                  </Typography>
                </Box>
              </Box>
            </motion.div>
          </Grid>

          {/* Navigation Links */}
          {Object.entries(footerLinks).map(([key, section], index) => (
            <Grid item xs={6} sm={3} md={2} key={key}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{
                    color: "white",
                    fontWeight: 600,
                    mb: 3,
                    fontFamily: "Montserrat",
                  }}
                >
                  {section.title}
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                  }}
                >
                  {section.links.map((link) => (
                    <Typography
                      key={link.label}
                      onClick={() => navigate(link.path)}
                      sx={{
                        color: "rgba(255, 255, 255, 0.6)",
                        fontSize: "0.875rem",
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                        "&:hover": {
                          color: "#06B6D4",
                          transform: "translateX(4px)",
                        },
                        fontFamily: "Montserrat",
                      }}
                    >
                      {link.label}
                    </Typography>
                  ))}
                </Box>
              </motion.div>
            </Grid>
          ))}

          {/* Newsletter Section */}
          {/* <Grid item xs={12} md={4}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.4 }}
              viewport={{ once: true }}
            >
              <Box sx={{ mt: { xs: 4, md: 0 } }}>
                <Typography
                  variant="h6"
                  sx={{
                    color: "white",
                    mb: 2,
                    fontFamily: "Montserrat",
                    fontWeight: 600,
                  }}
                >
                  Stay in the loop
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "rgba(255, 255, 255, 0.6)",
                    mb: 3,
                    fontFamily: "Montserrat",
                  }}
                >
                  Get updates about new features and improvements. No spam.
                </Typography>
                <Box
                  component="form"
                  sx={{
                    display: "flex",
                    gap: 1,
                    flexDirection: { xs: "column", sm: "row" },
                  }}
                  onSubmit={(e) => {
                    e.preventDefault();
                    // Handle newsletter subscription
                  }}
                >
                  <TextField
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email"
                    variant="outlined"
                    size="small"
                    sx={{
                      flex: 1,
                      "& .MuiOutlinedInput-root": {
                        color: "white",
                        backgroundColor: "rgba(255, 255, 255, 0.05)",
                        borderRadius: "8px",
                        "& fieldset": {
                          borderColor: "rgba(255, 255, 255, 0.1)",
                        },
                        "&:hover fieldset": {
                          borderColor: "rgba(255, 255, 255, 0.2)",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#06B6D4",
                        },
                      },
                      "& .MuiInputBase-input::placeholder": {
                        color: "rgba(255, 255, 255, 0.4)",
                      },
                    }}
                  />
                  <Button
                    type="submit"
                    variant="contained"
                    sx={{
                      bgcolor: "#06B6D4",
                      color: "white",
                      px: 3,
                      py: 1,
                      borderRadius: "8px",
                      textTransform: "none",
                      fontFamily: "Montserrat",
                      "&:hover": {
                        bgcolor: "#0891B2",
                      },
                    }}
                  >
                    Subscribe
                  </Button>
                </Box>
              </Box>
            </motion.div>
          </Grid> */}
        </Grid>

        {/* Bottom Bar */}
        <Box
          sx={{
            mt: 8,
            pt: 4,
            borderTop: "1px solid rgba(255, 255, 255, 0.1)",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexDirection: { xs: "column", sm: "row" },
            gap: 2,
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: "rgba(255, 255, 255, 0.6)",
              fontFamily: "Montserrat",
              display: "flex",
              alignItems: "center",
              gap: 0.5,
            }}
          >
            Copyright © {new Date().getFullYear()}{" "}
            <Box
              component="span"
              sx={{
                color: "#06B6D4",
                fontWeight: 600,
              }}
            >
              VenFlows
            </Box>{" "}
            | All rights reserved
          </Typography>
          <Link
            href="https://venustusy.com"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: "rgba(255, 255, 255, 0.4)",
              textDecoration: "none",
              fontFamily: "Montserrat",
              fontSize: "0.875rem",
              transition: "all 0.2s ease",
              display: "flex",
              alignItems: "center",
              gap: 0.5,
              "&:hover": {
                color: "#06B6D4",
              },
            }}
          >
            Crafted by{" "}
            <Box
              component="span"
              sx={{
                fontWeight: 600,
                background: "linear-gradient(90deg, #06B6D4, #22D3EE)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Venustusy
            </Box>
            <span className="material-icons" style={{ fontSize: "16px" }}>
              open_in_new
            </span>
          </Link>
        </Box>
      </Container>
    </Box>
  );
};
